/**
 * Credentials form.
 *
 * Shopify's contact form posts the whole page and comes back on a redirect,
 * which loses the applicant's place on the page. Here the form is retargeted
 * at a hidden iframe, so the post and anything Shopify answers with stay off
 * screen while the confirmation opens in place. Without JavaScript the form
 * posts normally and the success flag on the return URL opens the same
 * confirmation.
 */
function initCredentialsForm(scope) {
  const root = scope || document;

  root.querySelectorAll('form.credentials-form').forEach((form) => {
    if (form.dataset.bound === 'true') return;
    form.dataset.bound = 'true';

    const section = form.closest('.shopify-section') || document;
    const modal = section.querySelector('[data-credentials-modal]');
    const submitBtn = form.querySelector('[type="submit"]');
    const errorEl = form.querySelector('[data-credentials-error]');

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
    }

    /*
     * Shopify's spam-protection script can navigate the page to its captcha
     * challenge on its own, which no preventDefault can hold back. So the form
     * is posted natively into a hidden iframe instead: whatever Shopify sends
     * back — a redirect, a challenge — lands in there, and this page never
     * moves. The confirmation opens as soon as the submit leaves.
     */
    const sinkName = `credentials-sink-${form.id || Math.random().toString(36).slice(2)}`;
    let sink = document.getElementById(sinkName);

    if (!sink) {
      sink = document.createElement('iframe');
      sink.id = sinkName;
      sink.name = sinkName;
      sink.setAttribute('aria-hidden', 'true');
      sink.setAttribute('tabindex', '-1');
      sink.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none;';
      document.body.appendChild(sink);
    }

    form.setAttribute('target', sinkName);

    form.addEventListener('submit', () => {
      // Let the browser show its own validation messages first.
      if (!form.checkValidity()) return;

      clearError();
      openCredentialsModal(modal);

      // The native post is already on its way into the iframe by now.
      window.setTimeout(() => form.reset(), 100);
    });
  });

  // Close controls, and the success flag after a non-JS post.
  root.querySelectorAll('[data-credentials-modal]').forEach((modal) => {
    if (modal.dataset.bound === 'true') return;
    modal.dataset.bound = 'true';

    modal.querySelectorAll('[data-credentials-close]').forEach((btn) => {
      btn.addEventListener('click', () => closeCredentialsModal(modal));
    });

    // Clicking the dimmed area closes it; clicking the panel does not.
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeCredentialsModal(modal);
    });

    if (window.location.search.includes('contact_posted=true') || window.location.search.includes('customer_posted=true')) {
      openCredentialsModal(modal);
    }
  });
}

function openCredentialsModal(modal) {
  if (!modal) return;

  modal.classList.add('is-open');
  modal.removeAttribute('aria-hidden');
  document.body.style.overflow = 'hidden';

  const close = modal.querySelector('[data-credentials-close]');
  if (close) close.focus();

  document.addEventListener('keydown', onCredentialsKeydown);
}

function closeCredentialsModal(modal) {
  if (!modal) return;

  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';

  document.removeEventListener('keydown', onCredentialsKeydown);
}

function onCredentialsKeydown(event) {
  if (event.key !== 'Escape') return;

  document.querySelectorAll('[data-credentials-modal].is-open').forEach(closeCredentialsModal);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initCredentialsForm());
} else {
  initCredentialsForm();
}

// Theme editor: re-init when the section is re-rendered.
document.addEventListener('shopify:section:load', (event) => initCredentialsForm(event.target));
